// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Form-Validators-___Validators-module__container {
  color: var(--colors-red);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./app/components/Form/Validators/Validators.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".container {\n  color: var(--colors-red);\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-Form-Validators-___Validators-module__container`
};
export default ___CSS_LOADER_EXPORT___;
